import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCustomerCounts = (backend: string, token: string, search: string) => {
    return fetch(`${getApiUrl(backend)}get_customers_count?&search=${search}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getCustomerCounts